/**
 * Directive: resourceRequest
 */
angular.module('acme.common.directive.resourceRequest', [
  'acme.common.directive.scheduleDisplay',
  'acme.common.directive.resourceRequestTime',
  'acme.common.directive.resourceRequestNeed'
])
.directive('resourceRequest', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceRequest/resourceRequest.tpl.html',
      scope: {
        model: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs

      },

      controller: ['$scope', function($scope) {

        $scope.resourceRequest = {

          model: {},
          showSchedule: false,
          noteLength: 0,

          init: function() {
            $scope.$on('ResourceRequest::ToggleSchedule', this.onToggleSchedule);
          },

          isType: function(type) {
            return ($scope.model.type === type);
          },

          updateNoteLength: function() {
            var modelNoteLength;
            this.noteLength = $scope.model.notes.length || 0;

            if ($scope.model.notes && typeof($scope.model.notes) === 'string') {
              modelNoteLength = $scope.model.notes.match(/\n/g);
              this.noteLength += modelNoteLength ? modelNoteLength.length : 0;
            }
          },

          onToggleSchedule: function(e, data) {
            var self = $scope.resourceRequest;

            if (!data.showSchedule) {
              self.showSchedule = !self.showSchedule;
            }else{
              self.showSchedule = data.showSchedule;
            }
          }

        };

        $scope.resourceRequest.init();

      }]

    };

}]);